import {
  contextIsAvailable,
  extractTrackingPageContext,
} from '@aboutyou/legacy-shared/src/tracking/hooks/trackingHelpers'
import { trackAyCustomerDataOnce } from '@aboutyou/legacy-shared/src/tracking/utils/trackAyCustomerDataOnce'
import { OutfitDetailPageContext } from '@aboutyou/legacy-tracking-sdk'
import { exists } from 'helpers/exists'
import { useTrackingCustomer } from '@aboutyou/legacy-shared'
import { useTracking } from 'helpers/tracking/hooks/useTrackingContextAndClientV6'
import React, { FC, useEffect, useRef } from 'react'
import { useService } from 'services/utils/context'
import { useOdpStore } from 'store/context'

function useTrackOutfitDetailPageView(pageTitle: string) {
  const { pageContext, TrackingClient } = useTracking()
  const service = useService()
  const lastTrackedIdRef = useRef<string | undefined>(undefined)
  const customerDataPayload = useTrackingCustomer()

  const outfitId = useOdpStore(store => store.outfitId)
  const outfit = exists(outfitId) ? service.outfits.getById(outfitId) : null

  useEffect(() => {
    if (outfit && customerDataPayload) {
      if (
        lastTrackedIdRef.current !== outfitId &&
        contextIsAvailable(pageContext) &&
        !pageContext.disabled
      ) {
        const page = extractTrackingPageContext(pageContext)
        lastTrackedIdRef.current = outfit.id
        trackAyCustomerDataOnce(TrackingClient, customerDataPayload)
        TrackingClient?.trackOutfitView({
          page: { ...page, title: pageTitle } as OutfitDetailPageContext,
          customer: customerDataPayload,
        })
      }
    }
  }, [
    TrackingClient,
    outfit,
    outfitId,
    pageContext,
    pageTitle,
    customerDataPayload?.type,
  ])
}

const TrackOutfitDetailPageView: FC<
  React.PropsWithChildren<{ pageTitle: string }>
> = ({ pageTitle, children }) => {
  useTrackOutfitDetailPageView(pageTitle)

  return <>{children}</>
}

export default TrackOutfitDetailPageView
